import { createContext, useContext } from "react";

import { MAP_INITIAL_ZOOM } from "./map.constants";

/** Zoom published once per gesture by the map host's `zoomend` subscription. */
export const MapZoomContext = createContext<number | undefined>(undefined);

/**
 * Current map zoom from the single shared `zoomend` subscription. There is one context and one provider now that
 * Leaflet is gone, so this lives beside the context it reads.
 *
 * Falls back to the map's own initial zoom when read outside a provider, so a consumer never silently
 * computes against a zoom the map was never at.
 */
export const useMapLibreZoom = (): number =>
  useContext(MapZoomContext) ?? MAP_INITIAL_ZOOM;
